export default "__VITE_ASSET__022d6192__"